export default {
  // Hero section
  'hero.title': 'Professional Online Timer Tools',
  'hero.subtitle': 'Choose the perfect timing tool for your needs',
  
  // Tool cards
  'timer.title': 'Timer',
  'timer.description': 'Countdown timer for work, study, and life',
  'timer.longDescription': 'Countdown timer for productivity, cooking, and time management',
  'timer.button': 'Start Timer',
  
  'stopwatch.title': 'Stopwatch',
  'stopwatch.description': 'High-precision timing tool',
  'stopwatch.longDescription': 'High-precision stopwatch for sports, training, and precise timing',
  'stopwatch.button': 'Start Stopwatch',
  
  'worldclock.title': 'World Clock',
  'worldclock.description': 'View time zones around the world',
  'worldclock.longDescription': 'Real-time display of global major city times with intelligent time zone calculations',
  'worldclock.button': 'View World Clock',
  
  // Features section
  'features.title': 'Why Choose timer.today?',
  'features.reliable.title': 'Reliable & Accurate',
  'features.reliable.desc': 'Millisecond precision timing with browser-based reliability',
  'features.crossPlatform.title': 'Cross-Platform',
  'features.crossPlatform.desc': 'Works seamlessly on desktop, tablet, and mobile devices',
  'features.smartNotifications.title': 'Smart Notifications',
  'features.smartNotifications.desc': 'Sound alerts and desktop notifications when time is up',
  'features.easyToUse.title': 'Easy to Use',
  'features.easyToUse.desc': 'Clean interface with intuitive controls for all users',
  
  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};